import {observer} from "mobx-react-lite";
import {ChangeEvent, useEffect, useState} from "react";
import {useStore} from "@shared/store";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {Button} from "@shared/ui/Button";
import {Typography} from "@shared/ui/Typography/Typography";
import {TextField} from "@shared/ui/Textfield/TextField";
import {passwordIcon, playerIcon} from "@shared/assets/icons";
import {Form} from "../auth/Form";
import {ContentLayout} from "../ui";
import {SmartCaptcha} from "@yandex/smart-captcha";
import {registrationStore} from "../auth/registrationStore";
import {setValueToLocalStorage} from "@shared/helpers/localstorage.helper";

type PropsT = {}

export const Registration = observer(({}: PropsT) => {

    const {
        registrationKey, checkingValidKey, isNicknameExist, checkingExistNickname,
        nickname, password, setPassword, setNickname, registration, hasAllowRegistration,
        repeatedPassword, setRepeatedPassword, isValidKey
    } = registrationStore

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [isChecked, setIsChecked] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            if (isChecked && nickname.length > 1) {
                checkingExistNickname()
                setIsChecked(false)
            }
        }, 1000)

        return () => {
            clearTimeout(timer)
        }
    }, [isChecked, nickname]);

    const onChangeNicknameHandler = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        setNickname(e.currentTarget.value)
        setIsChecked(true)
    }

    const onChangePasswordHandler = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        setPassword(e.currentTarget.value)
    }

    const onChangeRepeatedPasswordHandler = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        setRepeatedPassword(e.currentTarget.value)
    }

    const regKeyURI = searchParams.get('key') as string

    useEffect(() => {
            checkingValidKey(regKeyURI).then(key => {
                if (key) {
                    searchParams.delete('key')
                    navigate('?' + searchParams.toString(), { replace: true })
                } else {

                }
            })
        console.log('regKeyURI', regKeyURI)
    }, [regKeyURI, searchParams, navigate]);

    // const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)


    return (
        <ContentLayout>
            <Form onSubmit={registration}>
                <ContentLayout.Header title={`Регистрация`}>
                    {isValidKey &&
                        <Button type={'submit'} fullWidth
                                disabled={!hasAllowRegistration || isChecked}
                                color={'success'}>
                            Зарегистрироваться
                        </Button>
                    }
                </ContentLayout.Header>
                {!isValidKey &&
                    <ContentLayout.Content>
                        <Typography fontWeight={'bold'} adaptiveFontSize={0.6} type={"span"} align={"center"}>
                            {regKeyURI !== registrationKey && 'Регистрация закрыта.'}
                        </Typography>
                    </ContentLayout.Content>
                }
                {isValidKey &&
                    <ContentLayout.Content>
                        <Form.Field>
                            <TextField
                                label={'Придумайте псевдоним...'}
                                icon={playerIcon}
                                value={nickname}
                                error={isNicknameExist && 'Псевдоним занят другим игроком'}
                                onChange={onChangeNicknameHandler}
                            />
                        </Form.Field>
                        <Form.Field>
                            <TextField
                                label={'Придумайте пароль...'}
                                icon={passwordIcon}
                                type={'password'}
                                value={password}
                                error={(password.length < 6 && !!password.length) && 'Пароль должен быть не менее 6 символов'}
                                onChange={onChangePasswordHandler}
                            />
                        </Form.Field>
                        <Form.Field>
                            <TextField
                                label={'Повторите пароль...'}
                                icon={passwordIcon}
                                type={'password'}
                                value={repeatedPassword}
                                error={(repeatedPassword !== password && repeatedPassword.length > 0) && 'Пароли не совпадают'}
                                onChange={onChangeRepeatedPasswordHandler}
                            />
                        </Form.Field>
                    </ContentLayout.Content>
                }
                <Form.Footer>
                    <Typography>
                        <Typography type={"span"} align={'center'}>
                            {`Есть аккаунт? `}
                        </Typography>
                        <Link to={'/login'}>
                            <Typography type={"span"} fontWeight={"bold"} align={'center'}>
                                Войти
                            </Typography>
                        </Link>
                    </Typography>
                </Form.Footer>
            </Form>
        </ContentLayout>
    )
})